import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { sectionSpacing } from "./section-spacing";
import { headingFontFamily } from "../heading-font";

export interface HowItWorksStep {
	id: string;
	eyebrow: string;
	icon: React.ReactElement;
	image: string;
	imageAlt: string;
	title: string;
	description: string;
}

export interface HowItWorksContent {
	steps: HowItWorksStep[];
}

export function HowItWorks({
	content: howItWorks,
}: {
	content: HowItWorksContent;
}) {
	return (
		<div>
			<Container
				maxWidth="lg"
				sx={{ py: sectionSpacing }}>
				<Stack spacing={8}>
					<Container maxWidth="lg">
						<Grid
							container
							spacing={{ xs: 2, md: 3 }}>
							{howItWorks.steps.map((step) => (
								<Grid
									key={step.id}
									size={{ xs: 12, sm: 6, md: 4 }}>
									<Card
										elevation={2}
										sx={{
											borderRadius: 4,
											height: "100%",
											overflow: "hidden",
										}}>
										<CardMedia
											alt={step.imageAlt}
											component="img"
											image={step.image}
											sx={{
												aspectRatio: "1 / 1",
												width: "100%",
												objectFit: "cover",
											}}
										/>
										<CardContent sx={{ p: 3 }}>
											<Stack spacing={2}>
												<div>
													<Chip
														color="secondary"
														icon={step.icon}
														label={step.eyebrow}
														size="small"
														variant="soft"
													/>
												</div>
												<Typography
													component="div"
													sx={{ fontFamily: headingFontFamily }}
													variant="h5">
													{step.title}
												</Typography>
												<Typography
													color="text.secondary"
													variant="body2">
													{step.description}
												</Typography>
											</Stack>
										</CardContent>
									</Card>
								</Grid>
							))}
						</Grid>
					</Container>
				</Stack>
			</Container>
		</div>
	);
}
